module.exports = require("@pb/kit-util-with-css-module");